import React, { Component } from "react";
import { connect } from "react-redux";
import "jqwidgets-scripts/jqwidgets/styles/jqx.material.css";
import { PDFReporte } from "../../components/utils/Pdf_produccion.js";
import "./style.css";
// import fondo from "../../assets/img/BGMACIZO.png";
import vid from "../../assets/img/Macizo Intro.mp4";
import Cover from "react-video-cover";
import { dominio } from "../../routes_backend/routes.jsx";
import {
  Grid,
  // Button,
  // ControlLabel,
  Row,
  /*Image,*/ Col,
} from "react-bootstrap";
import { Card } from "../../components/Card/Card";
import WelcomeHome from "./ComponentHome/WelcomeHome";


// import WelcomeHome from "./ComponentHome/WelcomeHome";
// import { Card } from "../../components/Card/Card";
// import Loading from "../../views/Loading";


// import {
//   Grid,

//   Row,
//   /*Image,*/ Col,
// } from "react-bootstrap";



export class Home extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      U_GrpReporte: "",

    };
  }


  
  componentDidMount() {
    this.data();

    this.resetInactivityTimeout();
    // Agrega escuchadores de eventos para manejar la interacción del usuario
    window.addEventListener('mousemove', this.handleUserActivity);
    window.addEventListener('keypress', this.handleUserActivity);
  }

  
  // Función para reiniciar el temporizador
  resetInactivityTimeout = () => {
    if (this.state.inactivityTimeout) {
      clearTimeout(this.state.inactivityTimeout);
    }

    const timeoutId = setTimeout(this.handleLogout, 3 * 60 * 1000); // 20 minutos
    this.setState({ inactivityTimeout: timeoutId });
  };

  // Función para manejar la acción de cierre de sesión
  handleLogout = () => {
    // Realiza aquí las acciones de cierre de sesión, como eliminar el token y redirigir al usuario a la página de inicio de sesión.
    localStorage.removeItem('TOKEN');
    localStorage.removeItem('token');
    this.props.history.push("/");
  };

  // Funciones que manejan las interacciones del usuario (por ejemplo, clics, pulsaciones de teclas, etc.)
  handleUserActivity = () => {
    this.resetInactivityTimeout();
  };

  componentWillUnmount() {
    if (this.state.inactivityTimeout) {
      clearTimeout(this.state.inactivityTimeout);
    }
    window.removeEventListener('mousemove', this.handleUserActivity);
    window.removeEventListener('keypress', this.handleUserActivity);
  }



  data = () => {
		this.setState({
			message: '',
			isLoading: true
		});
		const response = fetch(`${dominio}/getUsuariosAdmin`, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
			},
		
			});
		
			response
			.then(async (res) => {
				let data = await res.json();
        console.log(data);
				let temp_Data = [];
				data.forEach((element) => {
					let obj = {
						DocEntry: element.DocEntry,
						U_UserId: element.U_UserId,
						USER_CODE: element.USER_CODE,
						nombre: element.U_Nombre,
						apellido: element.U_Apellido,
						cargo: element.U_Cargo,
						email: element.U_email,
						is_available: element.U_is_available
					};
					temp_Data.push(obj);
          console.log(element.U_GrpReporte);

				});
				this.setState({
					message: '',
					isLoading: false,
					data: temp_Data,
					data_search: data
				});
        
			})
			.catch((error) => {
				console.log(error);
				this.setState({
					isLoading: false,
					message: 'error in the server'
				});
			});
	};

  render() {
    
    // const style = {
    //   backgroundImage: `url(${fondo})`,
    //   backgroundSize: "cover",
    //   backgroundRepeat: "no-repeat",
    //   backgroundPosition: "center",
    //   padding: '20%', // Agregar el padding deseado
    // };
    const videoOptions = {
      src: vid,
      autoPlay: false,
      muted: false,
      loop: true,
    };
  
    return (
    //   <div responsive="true">
    //   <div style={styles.style} responsive="true">
    
    //   </div>
    //   <div
    //     style={
    //       document.documentElement.clientWidth > 900
    //         ? styles.sectionStyle
    //         : styles.resize
    //     }
    //   >
    //     <div id="text" className="text">
    //       {/* <h1>Macizo</h1> */}
    //     </div>
    //     <div className="col-md-4">
    //       <div className="content" style={styles.fondo}>

    //       </div>
    //     </div>
    //   </div>
    // </div>
    <div className="content">
            <Grid fluid>
              <Row>
                <Col md={12}>
                  <Card
                    title=""
                    category=""
                    ctTableFullWidth
                    ctTableResponsive
                    content={
                      <div className="content">
                        <WelcomeHome
                          {...this.props}
                          dataUser={this.state.dataUser}
                        />
                      </div>
                    }
                  />
                </Col>
              </Row>
            </Grid>
          </div>
    );
  }
}

function mapStateToProps(state) {
  return {};
}

export default connect(mapStateToProps, { PDFReporte })(Home);
const styles = {
  fondo: {

    alignItems: "left",

  },
  jumboStyle: {
    width: "100%",
    height: "100%",
    background:
      "linear-gradient(to right bottom, rgba(0,1,40,0.5), rgba(0,78,146,0.05))",
  },
  style: {
    margin: "10px",
    backgroundSize: "cover",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    maxWidth: "70%",
    transform: "translate(20%, 0%)",


  },

  resize: {
    position: "absolute",
    padding: "2.5%",
    background:
      "linear-gradient(to right bottom, rgba(0,0,0,0.5), rgba(0,0,0,0.5))",
    zIndex: 2,
  },
  styleForgotMessage: {
    fontSize: "1.5rem",
    cursor: "pointer",
    color: "#FEFEFE",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
}